import type { IBookingData } from '@/entities/booking/model/types';

export function bookingAdapter(data: IBookingData): IBookingData {
  if (process.env.NEXT_PUBLIC_ENV === 'prod') return data;

  return {
    ...data,
    doctor: {
      ...data.doctor,
      avatar: `https://idoctor.kz/${data.doctor.avatar}`,
    },
  };
}
